import { render, staticRenderFns } from "./EventEdit.vue?vue&type=template&id=23d6d46b&scoped=true&lang=pug"
import script from "./EventEdit.vue?vue&type=script&lang=ts"
export * from "./EventEdit.vue?vue&type=script&lang=ts"
import style0 from "./EventEdit.vue?vue&type=style&index=0&id=23d6d46b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6d46b",
  null
  
)

export default component.exports